import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=1624a07c&scoped=true"
import script from "./GiftCards.vue?vue&type=script&lang=js"
export * from "./GiftCards.vue?vue&type=script&lang=js"
import style0 from "./GiftCards.vue?vue&type=style&index=0&id=1624a07c&prod&scoped=true&lang=css"
import style1 from "./GiftCards.vue?vue&type=style&index=1&id=1624a07c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624a07c",
  null
  
)

export default component.exports